/* eslint-disable no-console */
import uniq from 'lodash/uniq';

let debugKeys: string[] = [];

let simpleDebug: (key: string, ...data: unknown[]) => void;

if (typeof window !== 'undefined') {
  window.startDebugging = (debugKey: string) => {
    debugKeys = uniq([...debugKeys, debugKey]);
  };
  window.stopDebugging = (debugKey: string) => {
    debugKeys = debugKeys.filter(k => k !== debugKey);
  };
  window.showDebugKeys = () => {
    console.log('Debugging:', debugKeys);
  };
  window.clearDebugKeys = () => {
    debugKeys = [];
  };
  simpleDebug = (key: string, ...data: unknown[]) => {
    if (debugKeys.includes(key)) {
      console.log(...data);
    }
  };
} else {
  simpleDebug = () => undefined;
}

const wrapped = (key: string, ...data: unknown[]): void => simpleDebug(key, ...data);
export default wrapped;
